/* eslint-disable react-hooks/exhaustive-deps */
import React, { useEffect, useRef, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import { useTranslation } from "react-i18next";

import {
  ButtonContainer,
  ScreenContent,
  MainContainer,
  Title,
  HeaderWrapper,
  Form,
  Input,
  StyledLockIcon,
  StyledVisibilityOff,
  StyledVisibility,
  Field,
  SubmitButton,
  BounceDiv,
} from "./SetUpNewPasswordPage.styles";

import Footer from "../../../components/Footer/Footer";
import Header from "../../../components/Header/Header";
import Loader from "../../../components/Loader/Loader";

import { isValidPassword } from "../../../utils/utils";
import { ReactComponent as Loading } from "../../../assets/icons/loader-white.svg";
import openToast from "../../../utils/toast";

import { selectResetPasswordPending } from "../../../store/slices/auth/slice";
import { resetPassword } from "../../../store/slices/auth/asyncThunks";
import { selectedLocale } from "../../../store/slices/common/slice";
import OTPInput from "react-otp-input";

const SetUpNewPasswordPage = () => {
  const { t } = useTranslation();
  const [confirmPassword, setConfirmPassword] = useState("");
  const [newPassword, setNewPassword] = useState("");
  const dispatch = useDispatch();
  const [visibility, setVisibility] = useState(false);
  const [visibility2, setVisibility2] = useState(false);
  const navigate = useNavigate();
  const loading = useSelector(selectResetPasswordPending);

  const [checkValidation, setCheckValidation] = useState(false);
  const [otp, setOtp] = useState("");

  const toastId = useRef(null);

  const locale = useSelector(selectedLocale);
  const ar = locale === "ar";

  const handleVisibilityToggle = () => {
    setVisibility(!visibility);
  };
  const handleVisibilityToggle2 = () => {
    setVisibility2(!visibility2);
  };
  const handleSubmit = () => {
    setCheckValidation(true);
    if (validateForm()) {
      dispatch(resetPassword({ newPassword, code: otp }))
        .unwrap()
        .then(() => {
          openToast(
            toastId,
            "log-in-success",
            "success",
            t("password-successfully-reset")
          );
          navigate("/");
        })
        .catch((error) => {
          openToast(toastId, "new-password", "error", t(error.message));
        });
    }
  };

  const validateForm = () => {
    let formIsValid = true;

    if (!newPassword) {
      openToast(toastId, "sign-up", "error", t("password-is-required"));
      formIsValid = false;
      return;
    } else if (!isValidPassword(newPassword)) {
      openToast(toastId, "sign-up", "info", t("password-contain"));
      formIsValid = false;
      return;
    }
    if (!confirmPassword) {
      openToast(toastId, "sign-up", "error", t("confirm-password-is-required"));
      formIsValid = false;
      return;
    } else if (newPassword !== confirmPassword) {
      openToast(toastId, "sign-up", "error", t("password-dont-match"));
      formIsValid = false;
      return;
    }

    return formIsValid;
  };

  const handleKeyPress = (e) => {
    if (e.key === "Enter") {
      handleSubmit();
    }
  };

  useEffect(() => {
    document.addEventListener("keypress", handleKeyPress);
    window.scrollTo(0, 0);

    return () => {
      document.removeEventListener("keypress", handleKeyPress);
    };
  }, [handleKeyPress]);

  return (
    <>
      <MainContainer>
        <HeaderWrapper>
          <Header />
        </HeaderWrapper>

        <BounceDiv>
          <ScreenContent>
            <Title>{t("welcome-to-ygii")}</Title>

            <Form>
              <OTPInput
                containerStyle={{
                  flexWrap: "wrap",
                  alignItems: "center",
                  justifyContent: "center",
                  gap: 10,
                }}
                inputStyle={{
                  width: 55,
                  userSelect: "none",
                  height: 55,
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "center",
                  padding: 12,
                  fontSize: 18,
                  fontFamily: "Avenir-Medium",
                  letterSpacing: -0.2,
                  color: "#000",
                  borderRadius: 27.5,
                  border: "1px solid #7F7F98",
                  outline: "none",
                  backgroundColor: "#fff",
                  boxShadow: "0px 1px 5px 1px #48488820",
                }}
                shouldAutoFocus
                value={otp}
                placeholder={"----"}
                onChange={setOtp}
                numInputs={4}
                renderSeparator={
                  <span style={{ userSelect: "none", color: "transparent" }}>
                    -
                  </span>
                }
                renderInput={(props, i) => <input {...props} />}
              />
              <Field>
                <StyledLockIcon $ar={ar} />
                <Input
                  $ar={ar}
                  type={visibility ? "text" : "password"}
                  placeholder={t("new-password")}
                  $error={checkValidation && !newPassword}
                  value={newPassword}
                  onChange={(e) => setNewPassword(e.target.value)}
                />
                {visibility ? (
                  <StyledVisibility $ar={ar} onClick={handleVisibilityToggle} />
                ) : (
                  <StyledVisibilityOff
                    $ar={ar}
                    onClick={handleVisibilityToggle}
                  />
                )}
              </Field>
              <Field>
                <StyledLockIcon $ar={ar} />
                <Input
                  $ar={ar}
                  type={visibility2 ? "text" : "password"}
                  placeholder={t("confirm-password")}
                  $error={checkValidation && !confirmPassword}
                  value={confirmPassword}
                  onChange={(e) => setConfirmPassword(e.target.value)}
                />
                {visibility2 ? (
                  <StyledVisibility
                    $ar={ar}
                    onClick={handleVisibilityToggle2}
                  />
                ) : (
                  <StyledVisibilityOff
                    $ar={ar}
                    onClick={handleVisibilityToggle2}
                  />
                )}
              </Field>
            </Form>
            {!loading ? (
              <ButtonContainer>
                <SubmitButton onClick={handleSubmit}>
                  {t("set-up-new-password")}
                </SubmitButton>
              </ButtonContainer>
            ) : (
              <ButtonContainer>
                <SubmitButton disabled>
                  <Loading height={30} />
                </SubmitButton>
              </ButtonContainer>
            )}
          </ScreenContent>
        </BounceDiv>
      </MainContainer>
      {loading && <Loader />}
      <Footer ar={ar} />
    </>
  );
};

export default SetUpNewPasswordPage;
